
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./LeagueTabs.css";

const leagues = [
  { name: "Football", path: "/football", key: "football" },
  { name: "Crypto", path: "/crypto", key: "crypto" },
  { name: "Forex", path: "/forex", key: "forex" },
  { name: "Volatility", path: "/volatility", key: "volatility" },
  { name: "GrowPlan", path: "/Growth-Plan", key: "growPlan" },
  { name: "IceHockey", path: "/icehockey", key: "iceHockey" },
  { name: "TableTennis", path: "/table-tennis", key: "tableTennis" },
  { name: "Basketball", path: "/basketball", key: "basketball" },
];

const translations = {
  en: {
    football: "Football",
    crypto: "Crypto",
    forex: "Forex",
    volatility: "Volatility",
    growPlan: "GrowPlan",
    iceHockey: "Ice Hockey",
    tableTennis: "Table Tennis",
    basketball: "Basketball",
    opening: "Opening...",
  },

  fr: {
    football: "Football",
    crypto: "Crypto",
    forex: "Forex",
    volatility: "Volatilité",
    growPlan: "Plan de croissance",
    iceHockey: "Hockey sur glace",
    tableTennis: "Tennis de table",
    basketball: "Basket-ball",
    opening: "Ouverture...",
  },

  sw: {
    football: "Mpira wa Miguu",
    crypto: "Sarafu za Kidijitali",
    forex: "Forex",
    volatility: "Volatility",
    growPlan: "Mpango wa Ukuaji",
    iceHockey: "Hoki ya Barafu",
    tableTennis: "Tenisi ya Meza",
    basketball: "Mpira wa Kikapu",
    opening: "Inafungua...",
  },

  pt: {
    football: "Futebol",
    crypto: "Criptomoedas",
    forex: "Forex",
    volatility: "Volatilidade",
    growPlan: "Plano de Crescimento",
    iceHockey: "Hóquei no Gelo",
    tableTennis: "Tênis de Mesa",
    basketball: "Basquetebol",
    opening: "A abrir...",
  },

  es: {
    football: "Fútbol",
    crypto: "Criptomonedas",
    forex: "Forex",
    volatility: "Volatilidad",
    growPlan: "Plan de Crecimiento",
    iceHockey: "Hockey sobre Hielo",
    tableTennis: "Tenis de Mesa",
    basketball: "Baloncesto",
    opening: "Abriendo...",
  },

  ar: {
    football: "كرة القدم",
    crypto: "العملات الرقمية",
    forex: "الفوركس",
    volatility: "التقلبات",
    growPlan: "خطة النمو",
    iceHockey: "هوكي الجليد",
    tableTennis: "تنس الطاولة",
    basketball: "كرة السلة",
    opening: "جارٍ الفتح...",
  },

  zh: {
    football: "足球",
    crypto: "加密货币",
    forex: "外汇",
    volatility: "波动率",
    growPlan: "成长计划",
    iceHockey: "冰球",
    tableTennis: "乒乓球",
    basketball: "篮球",
    opening: "正在打开...",
  },

  hi: {
    football: "फुटबॉल",
    crypto: "क्रिप्टो",
    forex: "फॉरेक्स",
    volatility: "अस्थिरता",
    growPlan: "विकास योजना",
    iceHockey: "आइस हॉकी",
    tableTennis: "टेबल टेनिस",
    basketball: "बास्केटबॉल",
    opening: "खुल रहा है...",
  },

  bn: {
    football: "ফুটবল",
    crypto: "ক্রিপ্টো",
    forex: "ফরেক্স",
    volatility: "অস্থিরতা",
    growPlan: "উন্নয়ন পরিকল্পনা",
    iceHockey: "আইস হকি",
    tableTennis: "টেবিল টেনিস",
    basketball: "বাস্কেটবল",
    opening: "খোলা হচ্ছে...",
  },

  ru: {
    football: "Футбол",
    crypto: "Криптовалюта",
    forex: "Форекс",
    volatility: "Волатильность",
    growPlan: "План роста",
    iceHockey: "Хоккей",
    tableTennis: "Настольный теннис",
    basketball: "Баскетбол",
    opening: "Открытие...",
  },

  de: {
    football: "Fußball",
    crypto: "Krypto",
    forex: "Forex",
    volatility: "Volatilität",
    growPlan: "Wachstumsplan",
    iceHockey: "Eishockey",
    tableTennis: "Tischtennis",
    basketball: "Basketball",
    opening: "Wird geöffnet...",
  },

  it: {
    football: "Calcio",
    crypto: "Criptovalute",
    forex: "Forex",
    volatility: "Volatilità",
    growPlan: "Piano di crescita",
    iceHockey: "Hockey su ghiaccio",
    tableTennis: "Tennis da tavolo",
    basketball: "Pallacanestro",
    opening: "Apertura...",
  },

  nl: {
    football: "Voetbal",
    crypto: "Crypto",
    forex: "Forex",
    volatility: "Volatiliteit",
    growPlan: "Groeiplan",
    iceHockey: "IJshockey",
    tableTennis: "Tafeltennis",
    basketball: "Basketbal",
    opening: "Openen...",
  },

  tr: {
    football: "Futbol",
    crypto: "Kripto",
    forex: "Forex",
    volatility: "Volatilite",
    growPlan: "Büyüme Planı",
    iceHockey: "Buz Hokeyi",
    tableTennis: "Masa Tenisi",
    basketball: "Basketbol",
    opening: "Açılıyor...",
  },

  ja: {
    football: "サッカー",
    crypto: "暗号資産",
    forex: "外国為替",
    volatility: "ボラティリティ",
    growPlan: "成長プラン",
    iceHockey: "アイスホッケー",
    tableTennis: "卓球",
    basketball: "バスケットボール",
    opening: "開いています...",
  },

  ko: {
    football: "축구",
    crypto: "암호화폐",
    forex: "외환",
    volatility: "변동성",
    growPlan: "성장 계획",
    iceHockey: "아이스하키",
    tableTennis: "탁구",
    basketball: "농구",
    opening: "여는 중...",
  },

  vi: {
    football: "Bóng đá",
    crypto: "Tiền điện tử",
    forex: "Ngoại hối",
    volatility: "Biến động",
    growPlan: "Kế hoạch tăng trưởng",
    iceHockey: "Khúc côn cầu trên băng",
    tableTennis: "Bóng bàn",
    basketball: "Bóng rổ",
    opening: "Đang mở...",
  },

  th: {
    football: "ฟุตบอล",
    crypto: "คริปโต",
    forex: "ฟอเร็กซ์",
    volatility: "ความผันผวน",
    growPlan: "แผนการเติบโต",
    iceHockey: "ฮอกกี้น้ำแข็ง",
    tableTennis: "ปิงปอง",
    basketball: "บาสเกตบอล",
    opening: "กำลังเปิด...",
  },

  id: {
    football: "Sepak Bola",
    crypto: "Kripto",
    forex: "Forex",
    volatility: "Volatilitas",
    growPlan: "Rencana Pertumbuhan",
    iceHockey: "Hoki Es",
    tableTennis: "Tenis Meja",
    basketball: "Bola Basket",
    opening: "Membuka...",
  },

  ms: {
    football: "Bola Sepak",
    crypto: "Kripto",
    forex: "Forex",
    volatility: "Kemeruapan",
    growPlan: "Pelan Pertumbuhan",
    iceHockey: "Hoki Ais",
    tableTennis: "Pingpong",
    basketball: "Bola Keranjang",
    opening: "Sedang membuka...",
  },

  ur: {
    football: "فٹ بال",
    crypto: "کرپٹو",
    forex: "فاریکس",
    volatility: "اتار چڑھاؤ",
    growPlan: "ترقی کا منصوبہ",
    iceHockey: "آئس ہاکی",
    tableTennis: "ٹیبل ٹینس",
    basketball: "باسکٹ بال",
    opening: "کھل رہا ہے...",
  },

  fa: {
    football: "فوتبال",
    crypto: "ارز دیجیتال",
    forex: "فارکس",
    volatility: "نوسان",
    growPlan: "برنامه رشد",
    iceHockey: "هاکی روی یخ",
    tableTennis: "تنیس روی میز",
    basketball: "بسکتبال",
    opening: "در حال باز شدن...",
  },

  ha: {
    football: "Ƙwallon Ƙafa",
    crypto: "Kuɗin Dijital",
    forex: "Forex",
    volatility: "Sauyin Farashi",
    growPlan: "Shirin Ci Gaba",
    iceHockey: "Hockey na Kankara",
    tableTennis: "Tennis na Tebur",
    basketball: "Ƙwallon Kwando",
    opening: "Ana buɗewa...",
  },

  yo: {
    football: "Bọ́ọ̀lù Ẹlẹsẹ̀",
    crypto: "Owó Ẹlẹ́rọ̀",
    forex: "Forex",
    volatility: "Ìyípadà Ọjà",
    growPlan: "Ètò Ìdàgbàsókè",
    iceHockey: "Hoki Yìnyín",
    tableTennis: "Tẹ́níìsì Tábìlì",
    basketball: "Bọ́ọ̀lù Agbọn",
    opening: "Ń ṣí...",
  },

  zu: {
    football: "Ibhola",
    crypto: "Imali Yedijithali",
    forex: "Forex",
    volatility: "Ukuguquguquka",
    growPlan: "Uhlelo Lokukhula",
    iceHockey: "IHokhi Yeqhwa",
    tableTennis: "Ithenisi Yetafula",
    basketball: "Ibhola Lomphebezo",
    opening: "Iyavula...",
  },

  am: {
    football: "እግር ኳስ",
    crypto: "የዲጂታል ምንዛሬ",
    forex: "ፎሬክስ",
    volatility: "የዋጋ መለዋወጥ",
    growPlan: "የእድገት ዕቅድ",
    iceHockey: "የበረዶ ሆኪ",
    tableTennis: "የጠረጴዛ ቴኒስ",
    basketball: "የቅርጫት ኳስ",
    opening: "በመክፈት ላይ...",
  },

  so: {
    football: "Kubadda Cagta",
    crypto: "Lacagaha Dijitaalka",
    forex: "Forex",
    volatility: "Isbeddelka Qiimaha",
    growPlan: "Qorshaha Kobaca",
    iceHockey: "Hokiga Barafka",
    tableTennis: "Miiska Tennis-ka",
    basketball: "Kubadda Kolayga",
    opening: "Waa la furayaa...",
  },

  rw: {
    football: "Umupira w'Amaguru",
    crypto: "Ifaranga Ry'ikoranabuhanga",
    forex: "Forex",
    volatility: "Imihindagurikire",
    growPlan: "Gahunda y'Iterambere",
    iceHockey: "Hoki yo ku Rubura",
    tableTennis: "Teni yo ku Meza",
    basketball: "Basketball",
    opening: "Birafunguka...",
  },

  lg: {
    football: "Omupiira",
    crypto: "Ssente ez'Obukugu",
    forex: "Forex",
    volatility: "Enkyukakyuka",
    growPlan: "Enteekateeka y'Okukula",
    iceHockey: "Hockey ey'Omuzira",
    tableTennis: "Ttena ey'Okumeza",
    basketball: "Basketball",
    opening: "Kiggulawo...",
  },

  af: {
    football: "Sokker",
    crypto: "Kripto",
    forex: "Forex",
    volatility: " wisselvalligheid",
    growPlan: "Groeiplan",
    iceHockey: "Yshokkie",
    tableTennis: "Tafeltennis",
    basketball: "Basketbal",
    opening: "Maak oop...",
  },
};

const originalLabels = {
  football: "Football",
  crypto: "Crypto",
  forex: "Forex",
  volatility: "Volatility",
  growPlan: "GrowPlan",
  iceHockey: "IceHockey",
  tableTennis: "Table Tennis",
  basketball: "Basketball",
  opening: "Opening...",
};

const LeagueTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [language, setLanguage] = useState(() => {
    try {
      const savedLanguage = localStorage.getItem("language");
      return savedLanguage && translations[savedLanguage]
        ? savedLanguage
        : null;
    } catch {
      return null;
    }
  });

  const [loadingPath, setLoadingPath] = useState(null);

  useEffect(() => {
    const updateLanguage = () => {
      try {
        const savedLanguage = localStorage.getItem("language");
        setLanguage(
          savedLanguage && translations[savedLanguage]
            ? savedLanguage
            : null
        );
      } catch {
        setLanguage(null);
      }
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  // Chagua tab kulingana na ukurasa uliofunguliwa
  useEffect(() => {
    const currentLeague = leagues.find(
      (league) => league.path.toLowerCase() === location.pathname.toLowerCase()
    );

    if (currentLeague) {
      setLoadingPath(null);
    }
  }, [location.pathname]);

  const t = language
    ? translations[language] || originalLabels
    : originalLabels;

  const handleClick = (league) => {
    if (loadingPath) return;

    if (location.pathname.toLowerCase() === league.path.toLowerCase()) {
      return;
    }

    setLoadingPath(league.path);

    // Nenda moja kwa moja kwenye ukurasa uliochaguliwa
    navigate(league.path);
    setLoadingPath(null);
  };

  return (
    <div className="league-tabs">
      {leagues.map((league) => (
        <button
          key={league.key}
          type="button"
          className={`league ${
            location.pathname.toLowerCase() === league.path.toLowerCase()
              ? "active-league"
              : ""
          }`}
          onClick={() => handleClick(league)}
          disabled={loadingPath !== null}
          aria-current={
            location.pathname.toLowerCase() === league.path.toLowerCase()
              ? "page"
              : undefined
          }
        >
          {loadingPath === league.path
            ? t.opening
            : t[league.key]}
        </button>
      ))}
    </div>
  );
};

export default LeagueTabs;
